import React from 'react';
import Payments from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const AutomaticRechargeCredit = React.lazy(() => import('./AutomaticRechargeCredit'));
const AutomaticRechargeCreditPage = (props) => (
  <Payments>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <AutomaticRechargeCredit {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </Payments>
);

export default AutomaticRechargeCreditPage;
